// Helper function to merge selected characters with search/initial results
import type { FilterItem } from '@/features/fanfiction-filters/types/fanfiction-filters.types';

export const mergeSelectedCharacters = (
  dataList: FilterItem[],
  selectedIds: string[],
  idToNameMap: Record<string, string>,
  characterDataCache?: Record<string, FilterItem>,
): FilterItem[] => {
  const selectedSet = new Set(selectedIds);
  const missingSelected = Array.from(selectedSet)
    .filter((id) => !dataList.some((character) => character.id === id))
    .map((id) => {
      // Use cached full character data if available
      const cachedData = characterDataCache?.[id];
      if (cachedData) {
        return {
          ...cachedData,
          checked: true,
        };
      }
      // Fallback to minimal data
      return {
        id,
        name: idToNameMap[id] || id,
        count: 0,
        fandomTitle: '',
        checked: true,
      };
    });
  return [...missingSelected, ...dataList];
};
